export default __webpack_public_path__ + "static/media/upload_cloud_image.b15a35e7.svg";